import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

// Import global theme styles
import './styles/theme.css'

loadFonts()

createApp(App)
  .use(vuetify)
  .mount('#app')
